import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentPersonalizationCompleteData,
  type EnrollmentPersonalizationCompleteSubmitOutput,
} from '../../../models'
import { InvestmentRiskToleranceCategory } from '../../../models/enrollment/enrollment'

export const getEnrollmentPersonalizationCompleteDataMock: EnrollmentPersonalizationCompleteData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/portfolio-customized',
  enrollmentData: {
    userInfo: {
      investment: {
        riskTolerance: {
          type: InvestmentRiskToleranceCategory.Balanced_4,
          allocation: {
            equityPercent: 67,
            fixedIncomePercent: 29.5,
            cashEquivalentPercent: 3.5,
          },
        },
      },
    },
  },
}

export const submitEnrollmentPersonalizationCompleteDataMock: EnrollmentPersonalizationCompleteSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/welcome',
  enrollmentData: {
    userInfo: {
      investment: {
        riskTolerance: {
          type: InvestmentRiskToleranceCategory.Balanced_4,
          allocation: {
            equityPercent: 67,
            fixedIncomePercent: 29.5,
            cashEquivalentPercent: 3.5,
          },
        },
      },
    },
  },
}

export const mockGetEnrollmentPersonalizationCompleteData = graphql.mutation(
  'getEnrollmentPersonalizationCompleteData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentPersonalizationCompleteDataMock } })
  },
)

export const mockSubmitEnrollmentPersonalizationCompleteData = graphql.mutation(
  'submitEnrollmentPersonalizationCompleteData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentPersonalizationCompleteDataMock } })
  },
)

export const mockEnrollmentPersonalizationComplete = [
  mockGetEnrollmentPersonalizationCompleteData,
  mockSubmitEnrollmentPersonalizationCompleteData,
]
